<template>
  <div class="login container fontSize_14 color_333">
    <theHeader></theHeader>
    <div class="main text_center vertical_middle">
      <div class="left"></div>
      <div class="right">
        <div v-if="isLogin"
             class="login">
          <h3 class="header fontSize_18 color_333">后台管理登录</h3>
          <div class="login_area">
            <div class="login_wrap user_wrap mb_20">
              <input v-model="loginParams.userName"
                     type="text"
                     autocomplete
                     class="login_txt username_txt box_sizing"
                     placeholder="请输入用户名" />
            </div>
            <div class="login_wrap password_wrap">
              <input v-model="loginParams.password"
                     type="password"
                     autocomplete
                     class="login_txt password_txt box_sizing"
                     placeholder="请输入密码"
                     @keyup.enter="handleLogin()" />
            </div>
          </div>
          <div class="mb_20">
            <div @click="handleLogin"
                 class="btn text_center color_fff">登录</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 版权 -->
    <p class="copyright text_center fontSize_14" style="right: 700px;position: fixed;bottom: 30px;">© 2021-2023 qzztcn.com版权所有    信息产业部备案:
      <img src="/static/img/beian-bg.png" style="width: 16px;height: 16px;"><span><a style="color:skyblue;"
      target="_blank" rel="noopener" href="https://beian.miit.gov.cn/#/Integrated/recordQuery">闽ICP备06047499号-1</a></span></p>
  </div>
</template>

<script>
import theHeader from '@/components/layout/Header.vue';
export default {
  components: {
    theHeader,
  },
  data() {
    return {
      userType: 2,//2代表用户端，3代表服务商端
      isLogin: true,//true登录，false注册
      loginParams: {
        userName: '',
        password: '',
      },
    };
  },
  created() {
    // console.log(this.address);
  },
  methods: {
    //获取随机数
    randomString(length){
      var result = '';  
      var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';  
      var charactersLength = characters.length;  
      for (var i = 0; i < length; i++) {  
          result += characters.charAt(Math.floor(Math.random() * charactersLength));  
      }  
      return result;  
    },
     // 将 Unicode 字符串进行编码
    base64EncodeUnicode(str) {
      return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function(match, p1) {
        return String.fromCharCode('0x' + p1);
      }));
    },
    handleLogin() {
      sessionStorage.userName = this.loginParams.userName;
      if (this.checked) {
        sessionStorage.pwd = this.loginParams.password;
        sessionStorage.loginchecked = this.checked;
      }
      let loginParams = this.loginParams
      if (!loginParams.userName) {
        this.$message.warning("请输入您的账号");
        return;
      }
      if (!loginParams.password) {
        this.$message.warning("请输入您的密码");
        return;
      }
      const salt = this.randomString(5)
      const passwordStr = loginParams.password+"{"+salt+"}"
      const usernameStr = loginParams.userName+"{"+salt+"}"
      const newPassword = this.base64EncodeUnicode(this.base64EncodeUnicode(passwordStr))
      const newUsername = this.base64EncodeUnicode(this.base64EncodeUnicode(usernameStr))
      // console.log(salt,newPassword,usernameStr)
      this.$axios
        .post("/admin/login/v1", {
            // ...loginParams,
          password:newPassword,
          userName:newUsername 
        })
        .then(res => {
          console.log(res,'res')
          if (res.data.result) {
            sessionStorage.token_admin = res.data.token;
            sessionStorage.userId_admin = res.data.uid; 
            sessionStorage.isLogin_admin = true;
            sessionStorage.user = JSON.stringify(res.data.user);
            sessionStorage.right = JSON.stringify(res.data.right)
            this.$router.push("dashboard");
          }
          this.$message.warning(res.data.info);
        });
    },
  },
};
</script>

<style scoped>
input:-webkit-autofill,
textarea:-webkit-autofill,
select:-webkit-autofill {
  background-color: #fff;
  transition: background-color 50000s ease-in-out 0s;
}

input {
  background-color: transparent;
}

.login {
  position: relative;
  height: 100%;
}

.login_txt {
  background-repeat: no-repeat;
  background-position-x: 16px;
  background-position-y: 50%;
  border: solid 1px #dcdfe6;
  border-radius: 4px;
}

.password_wrap {
  background-image: url("../../static/img/login_password.png");
  background-repeat: no-repeat;
  background-position-x: 16px;
  background-position-y: 50%;
}

.user_wrap {
  background-image: url("../../static/img/login_user.png");
  background-repeat: no-repeat;
  background-position-x: 16px;
  background-position-y: 50%;
}

.login_txt {
  display: block;
  padding-left: 48px;
  width: 100%;
  height: 38px;
}

.color_2e5597 {
  color: #2e5597;
}

.mb_44 {
  margin-bottom: 44px;
}

.main {
  height: 100vh;
}

.left {
  display: inline-block;
  width: 456px;
  height: 303px;
  margin-right: 100px;
  vertical-align: middle;
  background-image: url("../../static/img/login_bg.png");
}

.right{
  display: inline-block;
  width: 340px;
  vertical-align: middle;
}

.login_area {
  margin-bottom: 44px;
}

.header {
  margin-bottom: 46px;
}

.btn {
  height: 40px;
  line-height: 40px;
  background: #2e5597;
  border-radius: 4px;
}

/* .login-wrap {
  position: relative;
  width: 100%;
  height: 100%;
  background: #606266;
}
.ms-title {
  text-align: center;
  font-size: 30px;
  color: #fff;
  margin-bottom: 40px;
}
.ms-login {
  width: 300px;
  padding: 40px;
  border-radius: 5px;
  background: #fff;
} */
</style>



// WEBPACK FOOTER //
// src/components/login.vue